import {
    Component,
    EventEmitter,
    Input,
    Output,
    SimpleChange,
    SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    templateUrl: './oneTimeVRecurringSelector.component.html',
    selector: 'onetime-v-recurring-selector',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: OneTimeVRecurringSelectorComponent,
        multi: true
    }],
    standalone: false
})
export class OneTimeVRecurringSelectorComponent implements ControlValueAccessor {

    // reactive forms functions
    private _onChangeFn: Function;
    private _onTouchedFn: Function;

    @Input() isOverridden: boolean = false;

    @Output() changed = new EventEmitter<string>();

    value: string;
    disabled: boolean;
    filter: string = '';

    registerOnChange(fn: any): void {
        this._onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouchedFn = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: string): void {
        this.value = value;
    }

    select(value: string): void {
        this.value = value;
        this.changed.emit(value);
    }
}
